import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Clienti from './CRM/Clienti/Clienti';
import LogIn from './CRM/LogIn';
import OpportunitaElenco from './CRM/Opportunita/OpportunitaElenco';
import Viaggi from './CRM/Viaggi/Viaggi';
import DocumentiCliente from './Magazzino/MagazzinoClienti/DocumentiCliente';
import LavorazioniCliente from './Magazzino/MagazzinoClienti/LavorazioniCliente';
import Lg from './Magazzino/MagazzinoClienti/LogInClienti';
import MagazzinoClienti from './Magazzino/MagazzinoClienti/MagazzinoClienti';
import MagazzinoClientiDettaglio from './Magazzino/MagazzinoClienti/MagazzinoClientiDettaglio';
import ElencoQualita from './Magazzino/MagazzinoProprieta/ElencoQualita';
import Magazzino from './Magazzino/MagazzinoProprieta/Magazzino';
import MagazzinoDettaglio from './Magazzino/MagazzinoProprieta/MagazzinoDettaglio';
import Preferiti from './Magazzino/MagazzinoProprieta/Preferiti';
import { PrivateRoute, PrivateMagClientiRoute } from './PrivateRoute';

function App() {
    return (
        <div>
            <BrowserRouter>
                <Routes>
                    <Route path="/clienti" element={<PrivateRoute />}>
                        <Route path="/clienti" element={<Clienti />} />
                    </Route>
                    <Route path="/opportunita" element={<PrivateRoute />}>
                        <Route path="/opportunita" element={<OpportunitaElenco />} />
                    </Route>
                    <Route path="/viaggi" element={<PrivateRoute />}>
                        <Route path="/viaggi" element={<Viaggi />} />
                    </Route>
                    <Route path="/login" element={<LogIn />}></Route>
                    <Route path="/loginclienti" element={<Lg />}></Route>
                    <Route path="/MagazzinoClienti" element={<PrivateMagClientiRoute />}>
                        <Route path="/MagazzinoClienti" element={<MagazzinoClienti />}></Route>
                    </Route>
                    <Route path="/MagazzinoClientiDettaglio" element={<PrivateMagClientiRoute />}>
                        <Route path="/MagazzinoClientiDettaglio" element={<MagazzinoClientiDettaglio />}></Route>
                    </Route>
                    <Route path="/LavorazioniCliente" element={<PrivateMagClientiRoute />}>
                        <Route path="/LavorazioniCliente" element={<LavorazioniCliente />}></Route>
                    </Route>
                    <Route path="/FattureCliente" element={<PrivateMagClientiRoute />}>
                        <Route
                            path="/FattureCliente"
                            element={<DocumentiCliente tipoDocumento="F,N"></DocumentiCliente>}
                        ></Route>
                    </Route>
                    <Route path="/DDTResoCliente" element={<PrivateMagClientiRoute />}>
                        <Route
                            path="/DDTResoCliente"
                            element={<DocumentiCliente tipoDocumento="C"></DocumentiCliente>}
                        ></Route>
                    </Route>
                    <Route path="/elencoqualita" element={<ElencoQualita></ElencoQualita>}></Route>
                    <Route path="/magazzino" element={<Magazzino></Magazzino>}></Route>
                    <Route path="/MagazzinoDettaglio" element={<MagazzinoDettaglio></MagazzinoDettaglio>}></Route>
                    <Route path="/Preferiti" element={<Preferiti></Preferiti>}></Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
